export const ENDPOINT = `https://${process.env.NEXT_PUBLIC_APPOINTMENT_DOMAIN_NAME}`;
